import questionIcon from '@iconify/icons-ant-design/question-outlined';
import { NavItem } from '../nav-item';

const deckardSupportLink =
  'https://deckardtech.atlassian.net/servicedesk/customer/portal/9';

export function DeckardSupport() {
  const onClick = () => window.open(deckardSupportLink);

  return (
    <NavItem
      id="support"
      icon={questionIcon}
      tooltip="Support"
      ariaLabel="Open customer support page"
      isActive={false}
      onClick={onClick}
    />
  );
}
